import { jsx as i } from "react/jsx-runtime";
import { R as l, a as n, b as p } from "./chunks/radio.oh7x5ZN_.js";
import "react";
import { Fieldset as R } from "./fieldset.js";
import { Flex as c } from "./flex.js";
const r = ({
  label: a,
  description: d,
  caption: e,
  error: m,
  children: t,
  ...o
}) => /* @__PURE__ */ i(l, { ...o, children: /* @__PURE__ */ i(n, { ...o, children: /* @__PURE__ */ i(
  R,
  {
    invalid: o.invalid,
    label: a,
    description: d,
    caption: e,
    error: m,
    children: /* @__PURE__ */ i(c, { direction: "column", gap: 300, children: t })
  }
) }) });
r.displayName = "RadioGroup";
r.Radio = p;
export {
  r as RadioGroup
};
//# sourceMappingURL=radio-group.js.map
